module.exports = __webpack_public_path__ + "img/bfd8e.de4146ed.svg";